module.exports = __webpack_public_path__ + "static/media/club.e005cd8c.svg";